import { styled } from '@mui/material/styles';

import Box from '~/common/components/Box';
import DatePicker from '~/common/components/DatePicker';
import Flex from '~/common/components/Flex';
import FormControl from '~/common/components/Forms/FormControl';
import FormLabel from '~/common/components/Forms/FormLabel';
import Input from '~/common/components/Inputs/Input';

import type { BankStatementAssociationDetail } from '../forms/AssetForm';

const StyledBankStatementContainer = styled(Flex)({
  flexDirection: 'column',
  justifyContent: 'flex-start',
  pointerEvents: 'none',
  opacity: '0.6',
  cursor: 'not-allowed',
  padding: '1rem',
});

type BankStatementFieldArrayProps = {
  bankStatements: BankStatementAssociationDetail[];
};

export function BankStatementFieldArray(
  props: Readonly<BankStatementFieldArrayProps>,
) {
  return (
    <StyledBankStatementContainer>
      {props.bankStatements.map((bankStatement, index) => (
        <BankStatementItem
          key={bankStatement._id}
          bankStatement={bankStatement}
          bankStatementNumber={index + 1}
        />
      ))}
    </StyledBankStatementContainer>
  );
}

const StyledAssetFieldArray = styled(Flex)`
  background-color: ${({ theme }) => theme.palette?.white};
  border: 1px solid ${({ theme }) => theme.palette?.gray[200]};
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  flex-direction: column;
  width: 100%;
`;
const StyledFormControl = styled(FormControl)<{ column?: 'first' | 'second' }>`
  position: relative;
  width: ${(props) =>
    props.column === 'first' ? 'calc(25% - 3rem)' : 'calc(25% - 1.5rem)'};
  margin-right: 3rem;
`;

const StyledStatementRow = styled(Flex)`
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 10px;
`;

const StyledStatementTile = styled(Box)`
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette?.gray[900]};
  text-decoration-color: ${({ theme }) => theme.palette?.gray[300]};
  text-decoration-thickness: 2px;
  margin-bottom: 1.125rem;
  width: 100%;
`;

function BankStatementItem({
  bankStatement,
  bankStatementNumber,
}: Readonly<{
  bankStatement: BankStatementAssociationDetail;
  bankStatementNumber: number;
}>) {
  return (
    <StyledAssetFieldArray marginBottom={'1rem'}>
      <StyledStatementTile>{`Bank Statement ${bankStatementNumber}`}</StyledStatementTile>
      <StyledStatementRow>
        <StyledFormControl column={'first'}>
          <DatePicker
            name="statementStartDate"
            label="Statement Start Date"
            value={bankStatement.userResponses.statementStartDate}
            tabIndex={-1}
            isDisabled
          />
        </StyledFormControl>
        <StyledFormControl column={'second'}>
          <DatePicker
            name="statementEndDate"
            label="Statement End Date"
            value={bankStatement.userResponses.statementEndDate}
            tabIndex={-1}
            isDisabled
          />
        </StyledFormControl>
        <StyledFormControl column={'first'}>
          <FormLabel htmlFor="numberOfDays">Number of Days</FormLabel>
          <Input
            id="numberOfDays"
            type="text"
            value={bankStatement.userResponses.statementNumberOfDays}
            isDisabled
          />
        </StyledFormControl>
      </StyledStatementRow>
    </StyledAssetFieldArray>
  );
}
